import { Switch, Route } from "react-router-dom";
import ZoomWrapper from "./ZoomWrapper";
import { useEffect, useState } from "react";

function Body(props) {
  const query = new URLSearchParams(window.location.search);
  const [meetingData, setMeetingData] = useState();
  const [signature, setSignature] = useState();
  const [hostEmail, setHostEmail] = useState("");
  const [clientName, setClientName] = useState("");
  const [isOperator, setIsOperator] = useState();
  const [user, setUser] = useState("");

  useEffect(() => {
    setMeetingData(JSON.parse(query.get("meetingData")));
    setSignature(query.get("signature"));
    setHostEmail(query.get("hostEmail"));
    setClientName(query.get("clientName"));
    setIsOperator(query.get("isOperator"));
    setUser(JSON.parse(query.get("user")));
  });

  return (
    <>
      {meetingData && (
        <>
          <Switch>
            <Route path="/">
              <ZoomWrapper
                subfolder={props.subfolder}
                meetingData={JSON.parse(query.get("meetingData"))}
                signature={query.get("signature")}
                hostEmail={query.get("hostEmail")}
                clientName={clientName}
                isOperator={query.get("isOperator")}
                user={
                  JSON.parse(query.get("user")) != null
                    ? JSON.parse(query.get("user"))
                    : null
                }
              ></ZoomWrapper>
            </Route>
          </Switch>
        </>
      )}
    </>
  );
}

export default Body;
